define(['jquery'], function ($) {
    return (elem, duration) => {
        $('html, body').animate(
            {
                scrollTop: elem.offset().top,
            },
            duration
        );
    };
});
